import pick from 'lodash-es/pick'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../constants/common'
import { FILTER_NAME_SUB_MENU } from '../../../constants/filter'
import {
  filterPermittedActionsWithDividers,
  parseActionsOnValidDivider,
} from '../../../utils/massActions'

import {
  CONTRACT_ITEM_ACTION_PERMISSION,
  ENTITY_TAB_CONTRACTS_ITEM_ACTION,
  ENTITY_TAB_CONTRACTS_ITEM_ACTIONS,
  ENTITY_TAB_CONTRACTS_SUB_TAB_QA_NAME,
} from './EntityTabContracts.constants'

export function getContractsPermanentFilters({ filterValues }) {
  return pick(filterValues, [FILTER_NAME_SUB_MENU])
}

export function parseContractsPermanentFilters(filters) {
  return [[FILTER_NAME_SUB_MENU, filters.sub_menu]]
}

export function getContractsSubTabQaName(item) {
  return ENTITY_TAB_CONTRACTS_SUB_TAB_QA_NAME[item.value]
}

export function getContractsItemActions(item, isArchiveSubTab) {
  if (isArchiveSubTab) {
    return EMPTY_LIST
  }

  const permissions = item?.permissions || EMPTY_OBJECT

  return ENTITY_TAB_CONTRACTS_ITEM_ACTIONS.filter(
    ({ value }) => permissions[CONTRACT_ITEM_ACTION_PERMISSION[value]]
  )
}

export function getContractsMassActions({
  isArchiveSubTab,
  permissions = EMPTY_OBJECT,
  t,
}) {
  return parseActionsOnValidDivider(
    filterPermittedActionsWithDividers([
      {
        label: t('ContractTable.ArchiveActionKey'),
        permission: permissions.can_archive && !isArchiveSubTab,
        value: ENTITY_TAB_CONTRACTS_ITEM_ACTION.Archive,
      },
    ])
  )
}

// Row click handlers need the whole item (flat id), not the default item.id.
export function getContractsRowClickProps(item) {
  return item
}

export function getContractsMassActionNotificationTitle({ t }) {
  return t('Notification.ContractsArchiveMassTitleKey')
}

export function isContractsArchiveAction(action) {
  return action === ENTITY_TAB_CONTRACTS_ITEM_ACTION.Archive
}

export function isContractsEditAction(action) {
  return action === ENTITY_TAB_CONTRACTS_ITEM_ACTION.Edit
}
